import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import {on, debounce, Options} from "../utils/decorators";

const Weglot = (<any>window).Weglot;
const localStorage = (<any>window).localStorage;

@Options({
    template: false,
    ui: {
        languageModal:  "[data-js-ui=language-popup]",
        acceptButton:   "[data-js-ui=switch-lang]",
        closeButton:    "[data-js-ui=close-modal]",
    }
})
export default class LanguagePopupView extends Marionette.View<Backbone.Model>{
    constructor(options?:object) {
        super(options);

        //Run other methods only after initialized
        const interval = setInterval(()=> {
            if (!Weglot.initialized) {
                return;
            }
            clearInterval(interval);
            this.showPopup();
        }, 100);
    }

    showPopup() {

        let userLang = navigator.language.replace(/[-_][a-z]+$/i, "");
        let availableLanguages = [];
        let weglotAvailableLanguages = Weglot.options.languages;
        let langSwicherOptActive = 'en'
        let activeLanguage = document.querySelector('.language-switcher__lang--active');

        if (activeLanguage) {
            langSwicherOptActive = activeLanguage.getAttribute('name');
        }

        for (let i = 0; i < weglotAvailableLanguages.length; i++) {
            let lang = weglotAvailableLanguages[i];

            availableLanguages.push(lang.language_to);
        }

        if (
            !localStorage.getItem('visited')
            && userLang !== 'en'
            && availableLanguages.indexOf(userLang) > -1
            && langSwicherOptActive !== userLang
        ) {
            this.ui.languageModal.show();
        }
    }

    @on("click @ui.closeButton")
    onCloseButtonClick(e) {

        localStorage.setItem('visited', '1');

        this.ui.languageModal.hide();
    }

    @on("click @ui.acceptButton")
    onAcceptButtonClick(e) {
        let userLang = navigator.language.replace(/[-_][a-z]+$/i, "");
        let langHost = null;

        for (let i = 0; i < Weglot.options.languages.length; i++) {
            let lang = Weglot.options.languages[i];

            if (userLang === lang.language_to) {
                var langObj = Weglot.options.languages[i];
            }
        }

        if (langObj.connect_host_destination && 'host' in langObj.connect_host_destination) {
            langHost = langObj.connect_host_destination.host;
        }

        localStorage.setItem('visited', '1');

        window.location.host = langHost;

    }
}



// WEBPACK FOOTER //
// ./@modules/views/language-popup.ts